// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(min-width:2520px){.browse-section .col-lg-6[data-v-24d9af6c]{max-width:932px}}.browse-section .text[data-v-24d9af6c]{color:#4d4d4d;line-height:1.5;text-align:left}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
